export default {
  state: () => ({
    breadcrumbs: [],
    breadcrumbsRouteTitles: {},
  }),

  mutations: {
    setBreadcrumbs(state, payload) {
      state.breadcrumbs = payload;
    },

    setBreadcrumbsRouteTitle(state, payload) {
      state.breadcrumbsRouteTitles = {
        ...state.breadcrumbsRouteTitles,
        ...payload,
      };
    },
  },

  getters: {
    breadcrumbs({ breadcrumbs, breadcrumbsRouteTitles }) {
      return breadcrumbs.map((item, index) => {
        const customTitle = breadcrumbsRouteTitles[item.route.name];
        let newTitle = '';
        if (customTitle) {
          newTitle = typeof customTitle === 'function' ? customTitle(item) : customTitle;
        }
        return {
          current: breadcrumbs.length == index + 1,
          title: newTitle ? newTitle : item.title,
          route: item.route,
        };
      });
    },
  },

  actions: {
    loadBreadcrumbs({ commit }, { routes, params }) {
      commit(
        'setBreadcrumbs',
        routes
          .filter(item => item.meta && item.meta.title)
          .map(item => ({
            title: item.meta.title,
            route: {
              params,
              name: item.name,
            },
          }))
      );
    },
  },
};
